export const checkbox = ({ colors, themeVariables, }) => ({
    background: {
        checked: colors.primary,
        unchecked: colors[themeVariables.inputBackgroundColor] ||
            themeVariables.inputBackgroundColor,
    },
    border: {
        color: colors[themeVariables.inputOutlineColor] ||
            themeVariables.inputOutlineColor,
        radius: 3,
    },
});
//# sourceMappingURL=checkbox.js.map